import { useState } from 'react';

const hints = [
    {
        text: 'One uppercase letter',
        hasError: false,
        isValid: (v: string) => /[A-Z]/.test(v)
    },
    {
        text: 'One lowercase letter',
        hasError: false,
        isValid: (v: string) => /[a-z]/.test(v)
    },
    {
        text: 'One number',
        hasError: false,
        isValid: (v: string) => /[0-9]/.test(v)
    },
    {
        text: 'One special character',
        hasError: false,
        isValid: (v: string) => /[\W_]/.test(v)
    },
    {
        text: '8 characters minimum',
        hasError: false,
        isValid: (v: string) => v.trim().length >= 8
    }
];

const hintsSummary =
    'Password must be at least 8 characters containing 1 uppercase letter, 1 lowercase letter, 1 number and 1 special character';

export const usePasswordWithHints = () => {
    const [passwordHints, setPasswordHints] = useState(hints);
    const mappedHints = passwordHints.map(({ isValid: _, ...hint }) => hint);

    const validatePasswordHints = (passwordValue: string) => {
        const validatedHints = passwordHints.map(({ text, isValid }) => ({
            text,
            isValid,
            hasError: !isValid(passwordValue)
        }));

        setPasswordHints(validatedHints);

        // if one of the hints has errors
        // return validation as false
        if (validatedHints.some((hint) => hint.hasError === true)) {
            return false;
        }

        return true;
    };

    const resetPasswordHints = () => {
        // reset password hints
        const resetHints = passwordHints.map(({ hasError: _, ...hint }) => ({
            ...hint,
            hasError: false
        }));

        setPasswordHints(resetHints);
    };

    return {
        passwordHints: mappedHints,
        validatePasswordHints,
        resetPasswordHints,
        hintsSummary
    };
};
